import React, { useState } from "react";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import OperationPanel from "../../components/Common/OperationPanel";
import CommonModal from "../../components/Common/CommonModal";
import AmenitiesTable from "../../components/Amenities/AmenitiesTable";
import AmenityModal from "../../Modal/Amenities/AmenityModal";
import AmenitiesTabs from "../../components/Amenities/AmenitiesTabs";

const AmenitiesList = () => {
  const [search, setSearch] = useState("");
  const [modal, setModal] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [tab, setTab] = useState("active");
  const [selected, setSelected] = useState(null);
  const [mode, setMode] = useState("create");

  return (
    <div className="page-content">
      <Breadcrumbs title="System" breadcrumbItem="Amenities" />

      <OperationPanel
        search={search}
        setSearch={setSearch}
        addLabel="Add Amenity"
        onAdd={() => {
          setMode("create");
          setSelected(null);
          setModal(true);
        }}
      />

      <AmenitiesTabs tab={tab} setTab={setTab} />

      <AmenitiesTable
        search={search}
        tab={tab}
        refresh={refresh}
        setMode={setMode}
        setSelected={setSelected}
        setModal={setModal}
      />

      <CommonModal
        isOpen={modal}
        toggle={() => setModal(false)}
        title={mode === "edit" ? "Edit Amenity" : "Create Amenity"}
      >
        <AmenityModal
          isModal
          mode={mode}
          selected={selected}
          onSuccess={() => {
            setModal(false);
            setRefresh((prev) => !prev);
          }}
        />
      </CommonModal>
    </div>
  );
};

export default AmenitiesList;